import './NoteComponent.css';
import { NebulaButton as x, NebulaFieldGroup as N, NebulaIcon as T, NebulaPopover as A, NebulaTextarea as E } from "@discoveryedu/nebula-components";
import { resolveComponent as u, openBlock as d, createElementBlock as s, Fragment as b, createElementVNode as h, normalizeClass as _, createVNode as a, withCtx as m, createBlock as k, toDisplayString as p, createCommentVNode as I, mergeProps as c, withDirectives as w, vShow as S } from "vue";
import { _ as D } from "./platform-components-assets/_plugin-vue_export-helper-es.js";
const B = {
  components: {
    NebulaButton: x,
    NebulaFieldGroup: N,
    NebulaIcon: T,
    NebulaPopover: A,
    NebulaTextarea: E
  },
  computed: {
    computedColor() {
      return this.highlight.color;
    },
    formattedHlDate() {
      var g, n;
      const t = ((g = this.note) == null ? void 0 : g.updatedOn) || new Date(Date.now()), l = (n = this.note) != null && n.updatedOn ? this.$t("Updated") : this.$t("Created"), i = new Intl.DateTimeFormat(this.locale), y = new Intl.DateTimeFormat(this.locale, { timeStyle: "short" }), o = i.format(t), e = y.format(t).split(" ").join("").toLowerCase();
      return `${l} ${o} - ${e}`;
    },
    highlight() {
      return this.note.highlight;
    },
    isInactive() {
      var t;
      return this.activeNote !== null && this.note.id !== ((t = this.activeNote) == null ? void 0 : t.id);
    },
    locale() {
      return (window.initData ? window.initData.locale : document.getElementsByTagName("html")[0].getAttribute("lang")).replace("_", "-");
    },
    noteId() {
      var t;
      return ((t = this.note) == null ? void 0 : t.id) || "empty-note";
    }
  },
  data() {
    return {
      contentTruncated: !0,
      isInEditMode: !1,
      isNoteClamped: null,
      updatedNoteText: ""
    };
  },
  emits: [
    "cancel-edit",
    "edit-mode",
    "note-delete",
    "highlight-color-change",
    "note-update-data",
    "note-text-changed"
  ],
  methods: {
    checkNoteClamp() {
      const t = this.$refs.noteText;
      if (this.openInEditMode) {
        this.isInEditMode = !0;
        return;
      }
      if (t.scrollHeight > t.clientHeight) {
        this.isNoteClamped = !0;
        return;
      }
      this.isNoteClamped = !1, this.contentTruncated = !1;
    },
    deleteNote() {
      this.$emit("note-delete", this.note);
    },
    handleCancel() {
      this.$emit("cancel-edit", this.note, this.updatedNoteText), !this.note.text && !this.note.id && this.$emit("note-delete", this.note);
    },
    handleColorChange(t) {
      this.highlight.setColor(t), this.$emit("highlight-color-change", this.highlight), this.$refs.colorPopover.closePopover();
    },
    onUpdateModelValue(t) {
      this.updatedNoteText = t, this.$emit("note-text-changed", t);
    },
    handleEdit() {
      this.isInEditMode = !0, this.$emit("edit-mode", this.isInEditMode, this.note);
    },
    handleSave() {
      this.note.text = this.updatedNoteText, this.$emit("note-update-data", {
        note: this.note,
        highlight: this.note.highlight,
        noteText: this.note.text
      });
    },
    toggleContentLength() {
      this.contentTruncated = !this.contentTruncated;
    }
  },
  mounted() {
    this.checkNoteClamp();
  },
  name: "NoteComponent",
  props: {
    activeNote: {
      type: Object,
      default: null
    },
    activeNoteFocused: {
      type: Boolean,
      default: null
    },
    note: {
      type: Object,
      required: !0
    },
    isDisabled: {
      type: Boolean,
      default: !1
    },
    noteSaved: {
      type: Boolean
    },
    openInEditMode: {
      type: Boolean,
      default: !1
    },
    buttonYellowAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonPinkAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonGreenAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonBlueAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonEditCancelAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonEditSaveAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonDeleteAttributes: {
      type: Object,
      default: () => ({})
    },
    buttonEditAttributes: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    isInEditMode(t) {
      t && this.$nextTick(() => {
        document.getElementById(`note-text--${this.noteId}`).focus();
      });
    }
  }
}, M = ["data-note-id"], H = {
  key: 1,
  class: "note__text"
}, O = {
  key: 1,
  class: "note__text--empty"
}, P = {
  key: 2,
  class: "note__toggle"
}, j = { class: "note__actions" }, z = { class: "note__actions-start" }, F = { class: "note__actions-end" }, V = { class: "note__actions-submit" }, G = { class: "note__warning" }, L = { class: "note__warning-text" };
function U(t, l, i, y, o, e) {
  const g = u("NebulaTextarea"), n = u("NebulaButton"), f = u("NebulaPopover"), C = u("NebulaIcon"), v = u("NebulaFieldGroup");
  return d(), s(b, null, [
    h("div", {
      class: _([
        "note__color-marker",
        `note__color-marker--${e.computedColor}`
      ]),
      "data-note-id": i.note.id
    }, null, 10, M),
    a(v, {
      class: "note__field-group",
      "input-id": `note-text--${e.noteId}`,
      "label-position": "top",
      "label-text": e.formattedHlDate
    }, {
      formElement: m(() => [
        o.isInEditMode && !i.noteSaved ? (d(), k(g, {
          key: 0,
          class: "note__textarea",
          "has-helper": !0,
          id: `note-text--${e.noteId}`,
          name: `note-text-${e.noteId}`,
          text: i.note.text,
          "v-model": i.note.text,
          ref: `noteTextarea--${e.noteId}`,
          "onUpdate:modelValue": e.onUpdateModelValue
        }, null, 8, ["id", "name", "text", "v-model", "onUpdate:modelValue"])) : (d(), s("div", H, [
          i.note.text ? (d(), s("p", {
            key: 0,
            class: _(["note__text-content", {
              "note__text-content--truncated": o.contentTruncated,
              "note__text-content--expanded": !o.contentTruncated
            }]),
            ref: "noteText"
          }, p(i.note.text), 3)) : (d(), s("p", O, p(t.$t("Add Text Here")), 1))
        ])),
        o.isNoteClamped && !o.isInEditMode ? (d(), s("div", P, [
          a(n, {
            class: "note__toggle-button",
            onClick: e.toggleContentLength,
            size: "xs",
            text: o.contentTruncated ? t.$t("View More") : t.$t("View Less"),
            type: "flat"
          }, null, 8, ["onClick", "text"])
        ])) : I("", !0),
        h("div", j, [
          h("div", z, [
            (d(), k(f, {
              "boundaries-selector": ".notes-panel",
              class: "note__highlight-color-selector",
              id: i.note.text ? `hl--${e.highlight.id}` : `hl--${e.highlight.id}-empty`,
              key: i.note.text ? `hl__${e.highlight.id}` : `hl__${e.highlight.id}-empty`,
              placement: "bottom",
              skidding: 8,
              ref: "colorPopover",
              "is-disabled": o.isInEditMode && !i.noteSaved
            }, {
              content: m(() => [
                a(n, c({
                  "aria-label": t.$t("Highlight Yellow"),
                  class: ["note__highlight-button note__highlight-button--yellow", { "note__highlight-button--active": e.computedColor === "yellow" }]
                }, i.buttonYellowAttributes, {
                  onClick: l[0] || (l[0] = (r) => e.handleColorChange("yellow")),
                  "icon-left": "checkbox-empty",
                  size: "s",
                  type: "flat",
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Add Highlight-Yellow"
                }), null, 16, ["aria-label", "class"]),
                a(n, c({
                  "aria-label": t.$t("Highlight Pink"),
                  class: ["note__highlight-button note__highlight-button--pink", { "note__highlight-button--active": e.computedColor === "pink" }]
                }, i.buttonPinkAttributes, {
                  onClick: l[1] || (l[1] = (r) => e.handleColorChange("pink")),
                  "icon-left": "checkbox-empty",
                  size: "s",
                  type: "flat",
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Add Highlight-Pink"
                }), null, 16, ["aria-label", "class"]),
                a(n, c({
                  "aria-label": t.$t("Highlight Green"),
                  class: ["note__highlight-button note__highlight-button--green", { "note__highlight-button--active": e.computedColor === "green" }]
                }, i.buttonGreenAttributes, {
                  onClick: l[2] || (l[2] = (r) => e.handleColorChange("green")),
                  "icon-left": "checkbox-empty",
                  size: "s",
                  type: "flat",
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Add Highlight-Green"
                }), null, 16, ["aria-label", "class"]),
                a(n, c({
                  "aria-label": t.$t("Highlight Blue"),
                  class: ["note__highlight-button note__highlight-button--blue", { "note__highlight-button--active": e.computedColor === "blue" }]
                }, i.buttonBlueAttributes, {
                  onClick: l[3] || (l[3] = (r) => e.handleColorChange("blue")),
                  "icon-left": "checkbox-empty",
                  size: "s",
                  type: "flat",
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Add Highlight-Blue"
                }), null, 16, ["aria-label", "class"])
              ]),
              trigger: m(({ popoverOpen: r }) => [
                (d(), k(n, {
                  "aria-expanded": r && "true" || "false",
                  "aria-haspopup": "true",
                  "aria-label": t.$t("Highlight Color Selector"),
                  class: _(`note__highlight-popover-button note__highlight-popover-button--${e.computedColor}`),
                  id: i.note.text ? `nebula-popover-trigger__hl--${e.highlight.id}` : `nebula-popover-trigger__hl--${e.highlight.id}-empty`,
                  key: i.note.text ? `popover-trigger__hl--${e.highlight.id}` : `popover-trigger__hl--${e.highlight.id}-empty`,
                  "icon-left": "checkbox-empty",
                  "icon-right": "caret-down",
                  "is-disabled": o.isInEditMode && !i.noteSaved,
                  type: "flat"
                }, null, 8, ["aria-expanded", "aria-label", "class", "id", "is-disabled"]))
              ]),
              _: 1
            }, 8, ["id", "is-disabled"]))
          ]),
          h("div", F, [
            h("div", V, [
              o.isInEditMode && !i.noteSaved ? (d(), s(b, { key: 0 }, [
                a(n, c({ class: "note__actions-cancel" }, i.buttonEditCancelAttributes, {
                  onClick: e.handleCancel,
                  size: "s",
                  text: t.$t("Cancel"),
                  type: "flat",
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Cancel"
                }), null, 16, ["onClick", "text"]),
                a(n, c({ class: "note__actions-save" }, i.buttonEditSaveAttributes, {
                  onClick: e.handleSave,
                  size: "s",
                  text: t.$t("Save"),
                  "is-disabled": i.isDisabled || o.updatedNoteText === "",
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Save"
                }), null, 16, ["onClick", "text", "is-disabled"])
              ], 64)) : (d(), s(b, { key: 1 }, [
                a(n, c({
                  "aria-label": t.$t("Delete"),
                  class: "note__actions-delete"
                }, i.buttonDeleteAttributes, {
                  onClick: e.deleteNote,
                  "icon-left": "trash",
                  type: "flat",
                  size: "s",
                  "is-disabled": e.isInactive,
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Delete"
                }), null, 16, ["aria-label", "onClick", "is-disabled"]),
                a(n, c({ class: "note__actions-edit" }, i.buttonEditAttributes, {
                  onClick: e.handleEdit,
                  text: t.$t("Edit"),
                  type: "ghost",
                  size: "s",
                  "is-disabled": e.isInactive,
                  "data-click-type": "TTS Note Action",
                  "data-click-name": "Edit"
                }), null, 16, ["onClick", "text", "is-disabled"])
              ], 64))
            ])
          ])
        ]),
        w(h("div", G, [
          a(C, {
            class: "note__warning-icon",
            "symbol-id": "warning",
            size: "s"
          }),
          h("p", L, p(t.$t("Please save your note to continue.")), 1)
        ], 512), [
          [S, o.isInEditMode && !i.noteSaved && !i.activeNoteFocused]
        ])
      ]),
      _: 1
    }, 8, ["input-id", "label-text"])
  ], 64);
}
const K = /* @__PURE__ */ D(B, [["render", U]]);
export {
  K as default
};
